module.exports = __webpack_public_path__ + "img/about_layout1.c6d9aa15.png";